
import $ from 'jquery';
import checkMetamask from './checkMetamask';
import claimTokenRequest from './claimTokenRequest';

const retryClaimToken = async () => {
  const marketplaceElements = $('.js-retry-claim-tokens');
  if (!marketplaceElements.length) {
    return;
  }

  marketplaceElements.off('click').on('click', async (e) => {
    if (!await checkMetamask()) {
      return;
    }

    const transactionId = $(e.currentTarget).data('transaction-id');
    const amount = $(e.currentTarget).data('amount');
    const walletType = $(e.currentTarget).data('wallet-type');

    const accounts = await web3Client.eth.getAccounts();
    const address = accounts[0];

    if (walletType === 'NFSG') {
      await claimTokenRequest(address, (amount * 1000000).toFixed(6), transactionId);
    }
  });
};

export default retryClaimToken;
